import { createContext, useContext, useReducer } from 'react';

// export const PresaleDispatch = React.createContext({})

function getAQuoteReducer(state: any, action: any) {
    switch (action.type) {
        case 'openQuote':
            return {
                ...state,
                isQuoteVisible: true,
            };
        case 'closeQuote':
            return {
                ...state,
                isQuoteVisible: false,
            };
    }
}

const initialState = {
    isQuoteVisible: false,
};

const StoreContext = createContext({} as any);
export const Provider = ({ children }: { children: any }) => {
    const [state, dispatch] = useReducer(getAQuoteReducer, initialState);
    return (
        <StoreContext.Provider
            value={{
                state,
                dispatch,
            }}
        >
            {children}
        </StoreContext.Provider>
    );
};

export const useDispatch = () => {
    const store = useContext(StoreContext);
    const dispatch = store.dispatch;
    return dispatch;
};

export const useStore = () => {
    const store = useContext(StoreContext);
    return store.state;
};
